import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";

import { Toaster } from "react-hot-toast";
import Landing from './pages/Landing'
import Home from './pages/home'
import ItemDetailsPage from './components/productDetails';
import QRCodeScannerPage from "./pages/ScanPage";
import OrdersPage from "./pages/OrdersPage";
import UserAccountPage from "./pages/UserProfile";
import CartPage from "./pages/Cart";
import PublicMenu from "./pages/PublicMenu";
import ShoutoutPage from "./pages/ShoutoutPage";
import ReturnToTable from "./pages/ReturnToTable";

function App() {
  return (
    <>
      <Router> 
        <Routes>
          <Route path="/" index element={<QRCodeScannerPage/>} />
          <Route path="/r/:slug" element={<PublicMenu/>} />
          <Route path="/shoutout/:token" element={<ShoutoutPage/>} />
          <Route path="/return-to-table" element={<ReturnToTable/>} />
          <Route path="/menu/:merchantId/:table/:revenueCenter" element={<Landing/>} />
          <Route path="/my-account" element={<UserAccountPage/>} />
          <Route path="/order" element={<Home/>} />
          <Route path="/cart" element={<CartPage/>} />
          <Route path="/my-account/orders" element={<OrdersPage/>} />
          <Route path="/item/:id" element={<ItemDetailsPage/>} />
        </Routes>
      </Router> 
      <Toaster 
        position="bottom-center"
        toastOptions={{
          className: 'bg-white dark:text-white dark:bg-slate-900 rounded-full text-sm',
        }}
        reverseOrder={false} 
      />
    </>
  );
}

export default App;
